/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { Assistant, Assistant$inboundSchema } from "./assistant.js";

export type ListAssistantsResult = {
  /**
   * Assistants for the current project.
   */
  assistants: Array<Assistant>;
};

/** @internal */
export const ListAssistantsResult$inboundSchema: z.ZodMiniType<
  ListAssistantsResult,
  unknown
> = z.object({
  assistants: z.array(Assistant$inboundSchema),
});

export function listAssistantsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListAssistantsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListAssistantsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListAssistantsResult' from JSON`,
  );
}
